import { render, staticRenderFns } from "./TutorsList.vue?vue&type=template&id=1d96c8f7&scoped=true&"
import script from "./TutorsList.vue?vue&type=script&lang=js&"
export * from "./TutorsList.vue?vue&type=script&lang=js&"
import style0 from "./TutorsList.vue?vue&type=style&index=0&id=1d96c8f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d96c8f7",
  null
  
)

export default component.exports